const identifyingGAPath = 'identifyingGA.';
const imagingPath = 'imaging.';

const identifyingGATrans = {
    WATCH_AND_DISCOVER_TITLE: identifyingGAPath + 'watchAndDiscover',
    WATCH_AND_DISCOVER_DESCRIPTION_TEXT: imagingPath + 'discoverDescription',
    VIDEO_DOWNLOAD_CAPTION: imagingPath + 'downloadCaption',

    DETECTION_TO_PROGRESSION: imagingPath + 'detectionTitle',
    PROGRESSION_DESCRIPTION: imagingPath + 'detectionDescription',
    DETECTION_FOOTER_TEXT: imagingPath + 'detectionFooter',

    DIAGNOSTIC_HALLMARK : imagingPath + 'diagnosticHallMarks'
}

export default identifyingGATrans